module.exports = __webpack_public_path__ + "img/LOGOAtWorks.71e73164.png";